'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getComponentName = exports.getComponentName = function getComponentName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var isStateless = exports.isStateless = function isStateless(Component) {
  return !(Component.prototype && Component.prototype.isReactComponent);
};

var stringify = exports.stringify = function stringify(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (typeof state === 'string') {
    return path.concat(state).join('.');
  }
  return Object.keys(state).reduce(function (prev, key) {
    return prev.concat(stringify(state[key], path.concat(key)));
  }, []);
};